// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"13":"85ff8282","292":"f95d3cb6"}[chunkId] + ".js";
};